export default {
  status: {
    SUBMITTED: 'SUBMITTED',
    PENDING: 'PENDING',
    COMPLETED: 'COMPLETED',
    FAILED: 'FAILED',
    UNKNOWN: 'UNKNOWN'
  },
  ETH: '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee',
  exchangeInfo: {
    ag: {
      name: 'X Blaster',
      description: '',
      img: require('@/modules/swap/assets/xblaster.png')
    },
    balancer: {
      name: 'Balancer',
      description: '',
      img: ''
    },
    compound: {
      name: 'Compound',
      description: '',
      img: ''
    },
    uniswap: {
      name: 'Uniswap',
      description: '',
      img: require('@/modules/swap/assets/uniswap.png')
    },
    uniswap_v2: {
      name: 'Uniswap v2',
      description: '',
      img: require('@/modules/swap/assets/uniswap.png')
    },
    uniswap_v3: {
      name: 'Uniswap v3',
      description: '',
      img: require('@/modules/swap/assets/uniswap.png')
    },
    bancor: {
      name: 'Bancor',
      description: '',
      img: require('@/modules/swap/assets/Bancor.png')
    },
    kyber: {
      name: 'Kyber Swap',
      description: '',
      img: require('@/modules/swap/assets/kyber.png')
    },
    zero_x: {
      name: '0x',
      description: '',
      img: require('@/modules/swap/assets/0x.png')
    },
    zero_x_v2: {
      name: '0x v2',
      description: '',
      img: require('@/modules/swap/assets/0x.png')
    },
    zero_x_v3: {
      name: '0x v3',
      description: '',
      img: require('@/modules/swap/assets/0x.png')
    },
    oasis: {
      name: 'Oasis',
      description: '',
      img: require('@/modules/swap/assets/Oasis.png')
    },
    synthetix: {
      name: 'Synthetix',
      description: '',
      img: require('@/modules/swap/assets/Synthetix.png')
    },
    curvefi: {
      name: 'Curve fi',
      description: '',
      img: require('@/modules/swap/assets/Curve.png')
    },
    curve_susd: {
      name: 'Curve sUSD',
      description: '',
      img: require('@/modules/swap/assets/Curve.png')
    },
    sushiswap: {
      name: 'Sushiswap',
      description: '',
      img: require('@/modules/swap/assets/Sushiswap.png')
    },
    one_inch: {
      name: 'One Inch',
      description: '',
      img: require('@/modules/swap/assets/1inch.png')
    },
    changelly: {
      name: 'Changelly',
      description: '',
      img: require('@/modules/swap/assets/Changelly.png')
    },
    default: {
      name: '',
      description: '',
      img: require('@/assets/images/icons/icon-swap.svg')
    }
  }
};
